import React, { Fragment } from 'react'
import { withRouteData, Link } from 'react-static'
import { Helmet } from "react-helmet"

const NewsPage = withRouteData(({ news }) => {

  let uri = `https://afrodesiamedia.com/`
  // console.log(news)

  return (
    <Fragment>
    <Helmet>
      <title> News - afrodesiamedia</title>
      <link rel="shortcut icon" href="/favicon.ico" />
      <meta property="og:url" content="https://afrodesiamedia.com" />
      <meta property="og:title" content="News" />
    </Helmet>
    <section className="News">

      <div className="container">
        <div className="news-list">
          {news.map((n, index) => (
            <article key={index}>
              <Link to={`/news/${n.permUrl}`}  alt={n.newsTitle}>
              <figure className="img-const">
                <img src={`${uri}${n.featuredImage.path}`} alt={n.newsTitle} /> 
              </figure>
                  
                  <span className="date">{n.date}</span>
                  <div className="news-ref">
                    <p>{n.newsTitle} </p>
                  </div>
                  
              </Link>
            </article>
          ))}
        
        </div>
      </div>
     
    </section>
  </Fragment>

  )
})

export default NewsPage


// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/News/components/NewsPage.js